import { isNil } from 'lodash';

/** Which way a stage change moved the claim along the conductor's stage flow. */
export type StageMoveDirection = 'open' | 'forward' | 'back' | 'lateral';

/**
 * Which way the claim moved from `previousKey` to `newKey`, read against `flow`, the conductor's stages in
 * the order the claim advances through them. The one place the stage bar and the log's stages rail decide
 * that a move went back, so the two cannot disagree.
 *
 * `open` for the stage the claim was opened in. A move from or to a stage outside the flow is `lateral`:
 * the stages are the organization's own, and an order the flow does not give is never guessed.
 */
export const stageMoveDirection = (flow: string[], previousKey: string | null, newKey: string): StageMoveDirection => {
  if (isNil(previousKey)) return 'open';

  const from = flow.indexOf(previousKey);
  const to = flow.indexOf(newKey);
  if (from === -1 || to === -1 || from === to) return 'lateral';

  return to > from ? 'forward' : 'back';
};
